import useSWR from 'swr';
import { host, fetcher } from '../tools.js'
import { useMemo } from 'preact/hooks';


export function getDataByDomain(searchString) {
  const url = `${host ?? ''}/registry-office/api/status?domain-name=${searchString}`
  const { data, error } = useSWR(url, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })

  return {
    domain: data,
    isLoading: !error && !data,
    isError: error
  }
}

export function getAllRegistrars() {
  const url = `${host ?? ''}/registry-office/api/registrars?epp=1&campaign_status=1`
  const { data, error } =  useSWR(url, fetcher, {
    loadingTimeout: 5000
  })
  
  const result = data?.data ?? []
  result.sort((rA, rB) => {
    const _sortValue = 'new_price_amount'
          rAName = rA.registrar_name.toLowerCase().trim(),
          rBName = rB.registrar_name.toLowerCase().trim();
    return (
      // Prioritize where _sortValue is not null (remove next check if this is uncommented)
      // !isNaN(parseInt(rA[_sortValue], 10)) && isNaN(parseInt(rB[_sortValue], 10)) ? 
      // -1 : 
      // isNaN(parseInt(rA[_sortValue], 10)) && !isNaN(parseInt(rB[_sortValue], 10)) ? 
      // 1 : 

      // Prioritize where _sortValue is not 0 or null
      +rA[_sortValue] && !+rB[_sortValue] ? 
      -1 : 
      !+rA[_sortValue] && +rB[_sortValue] ? 
      1 : 

      // Prioritize on _sortValue value (asc)
      +rA[_sortValue] - +rB[_sortValue] !== 0 ? 
      +rA[_sortValue] - +rB[_sortValue] : 

      // Prioritize when campaigns is not 0 or null
      // !!+rA.campaigns && !+rB.campaigns ? 
      // -1 : 
      // !+rA.campaigns && !!+rB.campaigns ? 
      // 1 : 

      // Prioritize on priority value (desc)
      +rB.priority - +rA.priority !== 0 ? 
      +rB.priority - +rA.priority : 

      // Prioritize on name (asc)
      rAName < rBName ? 
      -1 : 
      rAName > rBName ? 
      1 : 

      // Default
      0
    );
  })
  return {
    registrars: result,
    isLoading: !error && !data,
    isError: error
  }
}

export function filterRegistrars(fetchedRegistrars, filterValue, sortValue = 'new_price_amount' , isAsc = true) {
  const filteredAndSortedRegistrars = useMemo(() => 
      fetchedRegistrars
        ?.filter(registrar => 
          !filterValue || registrar.continent?.toLowerCase().includes(filterValue.toLowerCase())
        )
        .sort((rA, rB) => {
          const _sortValue = sortValue,
                rAName = rA.registrar_name.toLowerCase().trim(),
                rBName = rB.registrar_name.toLowerCase().trim();

          let result = 0;

          // Prioritize where _sortValue is not null (remove next check if this is uncommented)
          // !isNaN(parseInt(rA[_sortValue], 10)) && isNaN(parseInt(rB[_sortValue], 10)) ? 
          // -1 : 
          // isNaN(parseInt(rA[_sortValue], 10)) && !isNaN(parseInt(rB[_sortValue], 10)) ? 
          // 1 : 
          if (isAsc)
            result =  // Prioritize where _sortValue is not 0 or null
              +rA[_sortValue] && !+rB[_sortValue] ? 
              -1 : 
              !+rA[_sortValue] && +rB[_sortValue] ? 
              1 : 

              // Prioritize on _sortValue value (asc)
              +rA[_sortValue] - +rB[_sortValue] !== 0 ? 
              +rA[_sortValue] - +rB[_sortValue] : 

              // Prioritize when campaigns is not 0 or null
              // !!+rA.campaigns && !+rB.campaigns ? 
              // -1 : 
              // !+rA.campaigns && !!+rB.campaigns ? 
              // 1 : 

              // Prioritize on priority value (desc)
              +rB.priority - +rA.priority !== 0 ? 
              +rB.priority - +rA.priority : 

              // Prioritize on name (asc)
              rAName < rBName ? 
              -1 : 
              rAName > rBName ? 
              1 : 

              // Default
              0;
          else
            result =  // Prioritize where _sortValue is not 0 or null
            +rA[_sortValue] && !+rB[_sortValue] ? 
            -1 : 
            !+rA[_sortValue] && +rB[_sortValue] ? 
            1 : 

            // Prioritize on _sortValue value (desc) 
            // special desc logic change
            +rB[_sortValue] - +rA[_sortValue] !== 0 ? 
            +rB[_sortValue] - +rA[_sortValue] : 

            // Prioritize when campaigns is not 0 or null
            // !!+rA.campaigns && !+rB.campaigns ? 
            // -1 : 
            // !+rA.campaigns && !!+rB.campaigns ? 
            // 1 : 

            // Prioritize on priority value (desc)
            +rB.priority - +rA.priority !== 0 ? 
            +rB.priority - +rA.priority : 

            // Prioritize on name (asc)
            rAName < rBName ? 
            -1 : 
            rAName > rBName ? 
            1 : 

            // Default
            0;
          return result;
        })
    ,[ fetchedRegistrars, filterValue, sortValue, isAsc ]);

    return filteredAndSortedRegistrars;
  }

export function roundHeader() {
  return (
    <div class='rounded-t-home absolute  shadows bg-brandColor2 h-[60px] w-full top-[-60px] left-0'></div>
  )
}